import { computed as l, ref as v } from "vue";
import { createShallowClonedObject as E } from "./ghl-ui.es1324.js";
import { useSorter as ee } from "./ghl-ui.es1325.js";
import { createTreeMate as te } from "./ghl-ui.es1015.js";
import N from "./ghl-ui.es721.js";
import k from "./ghl-ui.es727.js";
import { call as o } from "./ghl-ui.es925.js";
import { warn as ne } from "./ghl-ui.es886.js";
function ce(a, { dataRelatedColsRef: m }) {
  const R = l(() => {
    const e = (t) => {
      for (let i = 0; i < t.length; ++i) {
        const n = t[i];
        if ("children" in n)
          return e(n.children);
        if (n.type === "selection")
          return n;
      }
      return null;
    };
    return e(a.columns);
  }), h = l(() => {
    const { childrenKey: e } = a;
    return te(a.data, {
      ignoreEmptyChildren: !0,
      getKey: a.rowKey,
      getChildren: (t) => t[e],
      getDisabled: (t) => {
        var i, n;
        return !!(!((n = (i = R.value) === null || i === void 0 ? void 0 : i.disabled) === null || n === void 0) && n.call(i, t));
      }
    });
  }), j = N(() => {
    const { columns: e } = a, { length: t } = e;
    let i = null;
    for (let n = 0; n < t; ++n) {
      const r = e[n];
      if (!r.type && i === null && (i = n), "tree" in r && r.tree)
        return n;
    }
    return i || 0;
  }), u = v({}), F = v(1), O = v(10), z = l(() => {
    const e = m.value.filter((n) => n.filterOptionValues !== void 0 || n.filterOptionValue !== void 0), t = {};
    return e.forEach((n) => {
      var r;
      n.type === "selection" || n.type === "expand" || (n.filterOptionValues === void 0 ? t[n.key] = (r = n.filterOptionValue) !== null && r !== void 0 ? r : null : t[n.key] = n.filterOptionValues);
    }), Object.assign(E(u.value), t);
  }), P = l(() => {
    const e = z.value, { columns: t } = a;
    function i(f) {
      return (c, s) => !!~String(s[f]).indexOf(String(c));
    }
    const { value: { treeNodes: n } } = h, r = [];
    return t.forEach((f) => {
      f.type === "selection" || f.type === "expand" || "children" in f || r.push([f.key, f]);
    }), n ? n.filter((f) => {
      const { rawNode: c } = f;
      for (const [s, g] of r) {
        let d = e[s];
        if (d == null || (Array.isArray(d) || (d = [d]), !d.length))
          continue;
        const C = g.filter === "default" ? i(s) : g.filter;
        if (g && typeof C == "function")
          if (g.filterMode === "and") {
            if (d.some((y) => !C(y, c)))
              return !1;
          } else {
            if (d.some((y) => C(y, c)))
              continue;
            return !1;
          }
      }
      return !0;
    }) : [];
  }), { sortedDataRef: b, deriveNextSorter: K, mergedSortStateRef: I, sort: T, clearSorter: A } = ee(a, {
    dataRelatedColsRef: m,
    filteredDataRef: P
  });
  m.value.forEach((e) => {
    var t;
    if (e.filter) {
      const i = e.defaultFilterOptionValues;
      e.filterMultiple ? u.value[e.key] = i || [] : i !== void 0 ? u.value[e.key] = i === null ? [] : i : u.value[e.key] = (t = e.defaultFilterOptionValue) !== null && t !== void 0 ? t : null;
    }
  });
  const W = l(() => {
    const { pagination: e } = a;
    if (e !== !1)
      return e.page;
  }), q = l(() => {
    const { pagination: e } = a;
    if (e !== !1)
      return e.pageSize;
  }), B = k(W, F), S = k(q, O), p = N(() => {
    const e = B.value;
    return a.remote ? e : Math.max(1, Math.min(Math.ceil(P.value.length / S.value), e));
  }), G = l(() => {
    const { pagination: e } = a;
    if (e) {
      const { pageCount: t } = e;
      if (t !== void 0)
        return t;
    }
  }), _ = l(() => {
    if (a.remote)
      return h.value.treeNodes;
    if (!a.pagination)
      return b.value;
    const e = S.value, t = (p.value - 1) * e;
    return b.value.slice(t, t + e);
  }), H = l(() => _.value.map((e) => e.rawNode));
  function J(e) {
    const { pagination: t } = a;
    if (t) {
      const { onChange: i, "onUpdate:page": n, onUpdatePage: r } = t;
      i && o(i, e), r && o(r, e), n && o(n, e), U(e);
    }
  }
  function L(e) {
    const { pagination: t } = a;
    if (t) {
      const { onPageSizeChange: i, "onUpdate:pageSize": n, onUpdatePageSize: r } = t;
      i && o(i, e), r && o(r, e), n && o(n, e), V(e);
    }
  }
  const M = l(() => {
    if (a.remote) {
      const { pagination: e } = a;
      if (e) {
        const { itemCount: t } = e;
        if (t !== void 0)
          return t;
      }
      return;
    }
    return P.value.length;
  }), Q = l(() => Object.assign(Object.assign({}, a.pagination), {
    // reset deprecated methods
    onChange: void 0,
    onUpdatePage: void 0,
    onUpdatePageSize: void 0,
    onPageSizeChange: void 0,
    "onUpdate:page": J,
    "onUpdate:pageSize": L,
    // writing merged props after pagination to avoid
    // pagination[key] === undefined
    // key still exists but value is undefined
    page: p.value,
    pageSize: S.value,
    pageCount: M.value === void 0 ? G.value : void 0,
    itemCount: M.value
  }));
  function U(e) {
    const { "onUpdate:page": t, onPageChange: i, onUpdatePage: n } = a;
    n && o(n, e), t && o(t, e), i && o(i, e), F.value = e;
  }
  function V(e) {
    const { "onUpdate:pageSize": t, onPageSizeChange: i, onUpdatePageSize: n } = a;
    i && o(i, e), n && o(n, e), t && o(t, e), O.value = e;
  }
  function X(e, t) {
    const { onUpdateFilters: i, "onUpdate:filters": n, onFiltersChange: r } = a;
    i && o(i, e, t), n && o(n, e, t), r && o(r, e, t), u.value = e;
  }
  function Y(e, t, i, n) {
    var r;
    (r = a.onUnstableColumnResize) === null || r === void 0 || r.call(a, e, t, i, n);
  }
  function Z(e) {
    U(e);
  }
  function $() {
    x();
  }
  function x() {
    D({});
  }
  function D(e) {
    w(e);
  }
  function w(e) {
    e ? e ? u.value = E(e) : process.env.NODE_ENV !== "production" && ne("data-table", "`filters` is not an object") : u.value = {};
  }
  return {
    treeMateRef: h,
    mergedCurrentPageRef: p,
    mergedPaginationRef: Q,
    paginatedDataRef: _,
    rawPaginatedDataRef: H,
    mergedFilterStateRef: z,
    mergedSortStateRef: I,
    hoverKeyRef: v(null),
    selectionColumnRef: R,
    childTriggerColIndexRef: j,
    doUpdateFilters: X,
    deriveNextSorter: K,
    doUpdatePageSize: V,
    doUpdatePage: U,
    onUnstableColumnResize: Y,
    // exported methods
    filter: w,
    filters: D,
    clearFilter: $,
    clearFilters: x,
    clearSorter: A,
    page: Z,
    sort: T
  };
}
export {
  ce as useTableData
};
